// extracted by mini-css-extract-plugin
export default {"tag":"tag--mitLP","published":"published--G3Pka","disabled":"disabled--xDugV","draft":"draft--Yd0oL"};